import { NgModule } from '@angular/core';
import { CommonModule } from '@app/common/common.module';
import { DimapCommonModule } from '@app/dimap/dimap-common.module';
import { DiagnosticsOverviewComponent } from '@app/dimap/diagnostics/diagnostics-overview/diagnostics-overview.component';
import {Ng2StateDeclaration, StateParams, UIRouterModule} from '@uirouter/angular';

export const diagnosticsOverviewState: Ng2StateDeclaration = {
  name: 'dimap.project.diagnostics',
  data: {
    title: 'Diagnostika',
  },
  url: '/diagnostics',
  params: {
  },
  views: {
    'content@dimap.project': {
      component: DiagnosticsOverviewComponent,
    }
  }
};

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: [
        diagnosticsOverviewState,
      ],
    }),
    CommonModule,
    DimapCommonModule,
  ],
  providers: [],
  declarations: [
    DiagnosticsOverviewComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class DiagnosticsModule {}
